import type { NftState, State } from 'types';

export default {
  getNft: (state: State): NftState => state.nft,
  getProp:
    <T extends keyof NftState>(propKey: T) =>
    (state: State) =>
      state.nft[propKey],
};
